import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Clock } from 'assets/icons/Clock.svg';
import TextInput from 'components/TextInput/TextInput';
import constants from 'Constants';
import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

import DateTimeField from './DateTimeField';
import TimeZoneSelect from './TimeZoneSelect/TimeZoneSelect';
import SwitchWithDisabledFeatureTooltip from '../SwitchWithDisabledFeatureTooltip';

const SchedulingToggleField = () => {
  const { t } = useTranslation();
  const {
    roomToEdit,
    isScheduling,
    setIsScheduling,
    roomForm: {
      control,
      formState: { errors },
      watch,
    },
  } = useCreateNewRoomDataContext();

  const isWaitingListEnabledWatch = watch('isWaitingListEnabled');
  const isPrivateRoom = watch('isPrivateRoom');
  const toggleIsScheduling = () => setIsScheduling((prev) => !prev);
  const dateErrors = errors.startDate || errors.startTime || errors.endDate || errors.endTime;
  const label = isPrivateRoom || isWaitingListEnabledWatch ? t('only_one_feature_active') : undefined;

  return (
    <div className="flex gap-5">
      <Clock className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
      <div className="w-full flex flex-col gap-3">
        <div className="w-full flex justify-between items-center">
          <span className="text-size-sm text-black">{t('scheduled')}</span>
          {!roomToEdit && (
            <SwitchWithDisabledFeatureTooltip
              checked={isScheduling}
              onChange={toggleIsScheduling}
              disabled={isPrivateRoom || isWaitingListEnabledWatch}
              label={label}
            />
          )}
        </div>
        {isScheduling && (
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <DateTimeField label={t('start')} dateName="startDate" timeName="startTime" control={control} />
              <DateTimeField label={t('end')} dateName="endDate" timeName="endTime" control={control} />
              <ErrorMessage message={dateErrors?.message} />
            </div>
            <TimeZoneSelect />
            <Controller
              name="description"
              control={control}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  id="description"
                  value={value}
                  hasError={!!errors.description?.message}
                  maxLength={constants.MAX_TOPIC_LENGTH + 1}
                  onChange={onChange}
                  placeholder={t('description_placeholder')}
                />
              )}
            />
            <ErrorMessage message={errors.description?.message} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SchedulingToggleField;
